export const TURNSTILE_ACTION = "turnstile-spin-v2"
export const TURNSTILE_SITEVERIFY_URL =
  "https://challenges.cloudflare.com/turnstile/v0/siteverify"
